/* @ngInject */
const myMovementSearchForm = (
  toaster,
  wagonUtils,
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myMovement: '=',
      mySearchedMovements: '=',
      id: '@myId',
    },
    template: require('./myMovementSearchForm.html'),

    /* @ngInject */
    controller: (
      $scope,
      utils,
      $$movement,
      labels
    ) => {
      $scope.moreOptions = false

      $scope.search = async (_myMovement) => {
        const myMovement = utils.copy(_myMovement)

        if (valueHandler.isObject(myMovement.area)) {
          myMovement.areaId = myMovement.area.id
        }
        if (valueHandler.isObject(myMovement.railway)) {
          myMovement.railwayId = myMovement.railway.id
        }

        myMovement.area = null
        myMovement.railway = null

        myMovement.wagonId = wagonUtils.stringToId(myMovement.wagonId)
        myMovement.dateBegin = utils.date.stringToServer(myMovement.dateBegin)
        myMovement.dateEnd = utils.date.stringToServer(myMovement.dateEnd)

        try {
          const response = await $$movement.request.getBySearch(myMovement)
          $scope.mySearchedMovements = response.movements
          toaster.message(response.message, response.color)
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.reinitForm = () => {
        $scope.mySearchedMovements.splice(0, $scope.mySearchedMovements.length)
        $scope.myMovement = $$movement.new.search()
      }

      $scope.menu = [{
        label: labels.movement.statements.park,
        id: 'park',
      }, {
        label: labels.movement.statements.unpark,
        id: 'unpark',
      }, {
        label: labels.movement.statements.move,
        id: 'move',
      },]
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myMovementSearchForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/directives/forms/myMovementSearchForm.js